import slug from "../lib/slug";
import MtdName from "./mtd-name";

export default function Anchor(id) {
    return MtdName(slug(id));
}
